import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: e, disableSSR: m, style: i, ...p }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-fabidingtou", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "32px-æ³å¸å®æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: l ? r(c, 0, "#0B0C0D") : "#0B0C0D",
        datafollowfill: l ? r(c, 0, "#0B0C0D") : "#0B0C0D"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M23.764 7.247a.9.9 0 0 0 .622-1.021l-.648-3.582a.9.9 0 1 0-1.771.32l.29 1.607A13.297 13.297 0 0 0 16 3.017c-7.374 0-13.352 5.978-13.352 13.352C2.648 23.742 8.626 29.72 16 29.72c7.374 0 13.352-5.977 13.352-13.351 0-1.84-.373-3.596-1.048-5.194a.9.9 0 0 0-1.658.7c.583 1.38.906 2.898.906 4.494 0 6.38-5.172 11.551-11.552 11.551S4.448 22.748 4.448 16.37C4.448 9.989 9.62 4.817 16 4.817c1.92 0 3.728.468 5.32 1.295l-1.563.477a.9.9 0 0 0 .526 1.722l3.48-1.064Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16 8.931a.9.9 0 0 1 .9.9v1.552h2.573a.9.9 0 0 1 0 1.8h-5.516a1.143 1.143 0 1 0 0 2.286h4.086a2.943 2.943 0 0 1 0 5.885H16.9v1.551a.9.9 0 0 1-1.8 0v-1.551h-2.572a.9.9 0 0 1 0-1.8h5.515a1.143 1.143 0 1 0 0-2.285h-4.086a2.943 2.943 0 0 1 0-5.886H15.1V9.831a.9.9 0 0 1 .9-.9Z"
        }
      )
    )
  )));
}, v = f;
export {
  v as default
};
